// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Label';



// WEBPACK FOOTER //
// ./components/Label/index.js